// extracted by mini-css-extract-plugin
module.exports = {"SummuaryExercisesList":"SummuaryExercisesList-module__SummuaryExercisesList___27vED","listDisable":"SummuaryExercisesList-module__listDisable___2A98G"};